export const ATTENDANCE_PURPOSE = 'orchestra_attendance';
export const isAttendanceGroup = group => group?.purpose === ATTENDANCE_PURPOSE;

export const getPerformanceAssignedIds = (sessions, assignments) => new Set(
    sessions.filter(session => !isAttendanceGroup(session))
        .flatMap(session => (assignments[session.id] || []).map(registrant => registrant.id))
);

// Attendance selection changes only this group's membership, never a performance assignment.
export const updateAttendanceMembers = (sessions, assignments, registrants, groupId, ids) => {
    if (!sessions.some(session => session.id === groupId && isAttendanceGroup(session))) return assignments;
    const assignedElsewhere = new Set(sessions.filter(session => isAttendanceGroup(session) && session.id !== groupId)
        .flatMap(session => (assignments[session.id] || []).map(registrant => registrant.id)));
    const byId = new Map([...registrants, ...(assignments[groupId] || [])].map(registrant => [registrant.id, registrant]));
    const members = [...new Set(ids)].filter(id => byId.has(id) && !assignedElsewhere.has(id)).map(id => byId.get(id));
    return { ...assignments, [groupId]: members };
};
